import React, { useState } from 'react';
import { Modal } from 'react-bootstrap';
import {Formik, Field, Form, ErrorMessage} from 'formik';
import * as Yup from 'yup';
import {
    Input,
    Select,
} from '../../../../_metronic/_partials/controls';

const CheckerRequestSchema = Yup.object().shape({
    status_checker: Yup.string().required('Status wajib diisi'),
    reason: Yup.string().when('status_checker', {
        is: value => value === 'REJECT',
        then: Yup.string().required('Keterangan wajib di isi untuk menolak'),
        otherwise: Yup.string(),
    }),
});

export function CheckerRequestForm({ saveChecker, onHide }) {
    // Inisialisasi data form
    const initChecker = {
        status_checker: '',
        reason: '',
    };

    const statusValue = [
        {
            value: 'SETTLE',
            name: 'APPROVED',
        },
        {
            value: 'REJECT',
            name: 'REJECT',
        },
    ];
    const [requestValue, setRequestValue] = useState(false);

    const changeType = (event) => {
        let value = event.target.value;

        switch ( value ) {
            case 'REJECT':
                setRequestValue(true);
                break;
            case 'SETTLE':
                setRequestValue(false);
                break;
            default:
                setRequestValue(false);
                initChecker.reason = '';
        }
    };
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={initChecker}
                validationSchema={CheckerRequestSchema}
                onSubmit={(values) => {
                    saveChecker(values);
                }}
            >
                {({ handleSubmit, handleChange, setFieldValue }) => (
                    <>
                        <Modal.Body className="overlay overlay-block cursor-default">
                            <Form>
                                <div className="col">
                                    <Select name="status_checker" label="Konfirmasi"
                                            onChange={(e) => {
                                                changeType(e);
                                                setFieldValue('status_checker', e.target.options[e.target.selectedIndex].value);
                                            }}
                                    >
                                        <option value="">--PILIH--</option>
                                        {
                                            statusValue.map(row =>
                                                <option key={row.value} value={row.value}>{row.name}</option>,
                                            )
                                        }
                                    </Select>
                                    <ErrorMessage name='status_checker'
                                                  render={msg => <div style={{color: 'red'}}>{msg}</div>}/>
                                </div>

                                {requestValue && (
                                    <div className="col-lg">
                                        <Field
                                            name="reason"
                                            component={Input}
                                            placeholder="Text"
                                            label="Keterangan"
                                        />
                                    </div>
                                )}

                            </Form>
                        </Modal.Body>
                        <Modal.Footer>
                            <button
                                type="button"
                                onClick={onHide}
                                className="btn btn-light btn-elevate"
                            >
                                Cancel
                            </button>
                            <> </>
                            <button
                                type="submit"
                                onClick={() => handleSubmit()}
                                className="btn btn-primary btn-elevate"
                            >
                                Confirm
                            </button>
                        </Modal.Footer>
                    </>

                )}
            </Formik>
        </>

    );
};
